export default __webpack_public_path__ + "static/media/group-option-male-selected.32126777.svg";